<template lang="pug">
section
  s-page-title(title='Фото из соцсетей')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.sub_type }}
          td {{ props.item.name }}
          td {{ props.item.author }}
          td {{ props.item.link }}
          td
            template()
              v-img(
                v-if='props.item.picture_url'
                :aspect-ratio='16/9'
                :lazy-src='props.item.picture_url'
                :src='props.item.picture_url'
                class='grey lighten-4'
                contain
              )
                v-layout(
                  slot='placeholder'
                  fill-height
                  align-center
                  justify-center
                  ma-0
                )
                  v-progress-circular(indeterminate color='primary')
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='socialgallery'
            )
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: true
      },
      {
        text: 'Тип контента',
        align: 'left',
        value: 'sub_type',
        width: '0%',
        sortable: true
      },
      {
        text: 'Название',
        align: 'left',
        sortable: true,
        value: 'name'
      },
      {
        text: 'Автор',
        align: 'left',
        value: 'author',
        width: '0%',
        sortable: true
      },
      {
        text: 'Внешняя ссылка',
        value: 'link',
        align: 'left',
        width: '50%',
        sortable: false
      },
      {
        text: 'Картинка',
        value: 'picture',
        align: 'left',
        width: '50%',
        sortable: false
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    sorting: {
      opened: false,
      resource: 'socialgallery',
      itemValue: 'id',
      itemText: 'name'
    }
  }),

  created() {
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Content.SocialGallery.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter
        }
      })
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ id })
          this.fetch()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('content/socialgallery', ['fetchList', 'destroy']),
    ...mapMutations('content/socialgallery', ['setDataFilter'])
  },

  computed: {
    ...mapState('content/socialgallery', ['total', 'dataFilter']),
    ...mapGetters('content/socialgallery', ['list', 'isLoading']),
  }
}
</script>
